export const apiCreate = (): string => '/commercial/contractProgress/'
export const apiList = (id?: string): string =>
  !id
    ? '/commercial/contractProgress/'
    : `/commercial/contractProgress/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/contractProgress/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/contractProgress/${id}`
